module.exports = __webpack_public_path__ + "img/DerAufprall5.2f87b1c3.jpg";